import React from 'react';
import './Footer.css';
import versionHistory from '../../data/versionHistory.json';
import { format, parse } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const Footer = ({ onShowHistory }) => {
  const latestUpdate = versionHistory[0];

  if (!latestUpdate) {
    return (
       <div className="app-footer">
        Prototype by <a href="mailto:contact@ambitioninnovationcreativity.com" target="_blank" rel="noopener noreferrer">Ambition Innovation Creativity</a>
      </div>
    );
  }

  const { version, date, notes } = latestUpdate;
  const dateObj = parse(date, 'yyyy-MM-dd HH:mm', new Date());
  const zonedDate = toZonedTime(dateObj, 'America/New_York');
  const updatedDate = format(zonedDate, 'MMM dd, yyyy');
  const updatedTime = format(zonedDate, 'hh:mm a');

  return (
    <div className="app-footer">
      <div>
        Prototype by <a href="mailto:contact@ambitioninnovationcreativity.com" target="_blank" rel="noopener noreferrer">Ambition Innovation Creativity</a>
      </div>
      <div className="version-info">
        <span className="version-number">{version}</span>
        <span className="update-details">
          Updated on {updatedDate} at {updatedTime} EST <br />
          ({notes})
        </span>
        <button onClick={onShowHistory} className="view-history-button">View History</button>
      </div>
    </div>
  );
};

export default Footer; 